module.exports = __webpack_public_path__ + "img/pcdtzlsc.a972fe80.png";